<div id="character-counter">
    <span id="current-length">{{ text().length }}</span>
    <span id="maximum-length">/{{ maxLength() }}</span>
</div>
